import React from 'react'
import { Link } from "react-router-dom";
import HomeServices from '../home/HomeServices';


const Services = () => {
    return (
        <>

            <div style={{overflow:"hidden"}}>
                <section className="section-breadcrumb main-wrapper">
                    <div className="breadcrumb-area">
                        <div className="container">
                            <div className="breadcrumb-wrapper">
                                <nav className="breadcrumb">
                                    <Link className="breadcrumb-item" to="/">Home</Link>
                                    <span className="breadcrumb-item active" aria-current="page">Services</span>
                                </nav>
                                <h1 className="breadcrumb-title">View All Services</h1>
                            </div>
                            <div className="breadcrumb-bg-block">
                                <img src="assets/images/breadcrumb-bg.jpg" alt="breadcrumb-bg" width={1920} height={448} className="img-cover" />
                                <img src="assets/images/breadcrumb-shape.png" alt="breadcrumb-shape" width={1033} height={448} />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="section-service" style={{ margin: "-40px" }}>
                    <div className="section-space section-space-bottom-huge">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-10 col-xl-8 col-xxl-6">
                                    <div className="section-content-block text-center mb-5">
                                        <span className="section-tag">Welcome to Rahul Logistics Katni</span>
                                        <h2 className="section-title is-text-dark">
                                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                                All Services
                                            </div>
                                        </h2>
                                        <p className="section-text max-width-sm">To be the most trusted and innovative logistics partner for businesses in India and across the globe. Delivering Excellence, Every Mile of the Way.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row g-4">

                                <div className="col-md-6 col-xl-4">
                                    <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                        <div className="service-image-block">
                                            <a to="service-details.html" className="service-image-link">
                                                <img src="assets/images/service-thumbnail-2.jpg" alt="service-thumbnail-1" width={364} height={266} className="img-cover service-thumbnail" />
                                            </a>
                                            <div className="service-icon">
                                                <img src="assets/images/icons/service-icon-2.svg" alt="service-icon-1" width={41} height={41} />
                                                <img src="assets/images/icons/service-icon-hover-2.svg" alt="service-icon-hover-1" width={41} height={41} />
                                            </div>
                                        </div>
                                        <div className="service-content">
                                            <Link to="/road-transportation" className="service-link">Road Transportation</Link>
                                            <p className="service-summery">At  Rahul Logistics , we pride ourselves on offering top-tier logistics solutions tailored to your specific requirements.</p>
                                            <br/>   
                                            <Link to="/road-transportation" className="btn btn-secondary-outline">
                                                Read More
                                                <div className="btn-icon btn-icon-sm">
                                                    <span>
                                                        <i className="fa-regular fa-arrow-right" />
                                                    </span>
                                                    <span>
                                                        <i className="fa-regular fa-arrow-right" />
                                                    </span>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xl-4">
                                    <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                        <div className="service-image-block">
                                            <Link to="/rail-transportation" className="service-image-link">
                                                <img src="assets/images/service-thumbnail-4.jpg" alt="service-thumbnail-4" width={364} height={266} className="img-cover service-thumbnail" />
                                            </Link>
                                            <div className="service-icon">
                                                <img src="assets/images/icons/service-icon-4.svg" alt="service-icon-4" width={41} height={41} />
                                                <img src="assets/images/icons/service-icon-hover-4.svg" alt="service-icon-hover-4" width={41} height={41} />
                                            </div>
                                        </div>
                                        <div className="service-content">
                                            <Link to="/rail-transportation" className="service-link">Rail Transportation</Link>
                                            <p className="service-summery">At Rahul Logistics, based in Katni, we provide fast, reliable, and cost-efficient logistics solutions through our Rail Services in Katni.</p>
                                            <Link to="/rail-transportation" className="btn btn-secondary-outline">
                                                Read More
                                                <div className="btn-icon btn-icon-sm">
                                                    <span>
                                                        <i className="fa-regular fa-arrow-right" />
                                                    </span>
                                                    <span>
                                                        <i className="fa-regular fa-arrow-right" />
                                                    </span>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xl-4">
                                    <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                        <div className="service-image-block">
                                            <Link to="/air-transportation" className="service-image-link">
                                                <img src="assets/images/service-thumbnail-3.jpg" alt="service-thumbnail-3" width={364} height={266} className="img-cover service-thumbnail" />
                                            </Link>
                                            <div className="service-icon">
                                                <img src="assets/images/icons/service-icon-3.svg" alt="service-icon-3" width={41} height={41} />
                                                <img src="assets/images/icons/service-icon-hover-3.svg" alt="service-icon-hover-1" width={41} height={41} />
                                            </div>
                                        </div>
                                        <div className="service-content">
                                            <Link to="/air-transportation" className="service-link">Air Transportation</Link>
                                            <p className="service-summery">At Rahul Logistics, based in Katni, we understand the importance of speed and reliability when it comes to transporting your critical shipments.</p>
                                            <Link to="/air-transportation" className="btn btn-secondary-outline">
                                                Read More
                                                <div className="btn-icon btn-icon-sm">
                                                    <span>
                                                        <i className="fa-regular fa-arrow-right" />
                                                    </span>
                                                    <span>
                                                        <i className="fa-regular fa-arrow-right" />
                                                    </span>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/images/service-thumbnail-1.jpg" alt="service-thumbnail-1" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        <div className="service-icon">
                                            <img src="assets/images/icons/service-icon-1.svg" alt="service-icon-1" width={41} height={41} />
                                            <img src="assets/images/icons/service-icon-hover-1.svg" alt="service-icon-hover-1" width={41} height={41} />
                                        </div>
                                    </div>
                                    <div className="service-content">
                                        <a to="service-details.html" className="service-link">Maritime Transportation</a>
                                        <p className="service-summery">We are committed to providing the best services to ensure
                                            your success.</p>
                                        <a to="service-details.html" className="btn btn-secondary-outline">
                                            Read More
                                            <div className="btn-icon btn-icon-sm">
                                                <span>
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                                <span>
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/images/service-thumbnail-5.jpg" alt="service-thumbnail-5" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        <div className="service-icon">
                                            <img src="assets/images/icons/service-icon-5.svg" alt="service-icon-5" width={41} height={41} />
                                            <img src="assets/images/icons/service-icon-hover-5.svg" alt="service-icon-hover-5" width={41} height={41} />
                                        </div>
                                    </div>
                                    <div className="service-content">
                                        <a to="service-details.html" className="service-link">Maritime Transportation</a>
                                        <p className="service-summery">We are committed to providing the best services to ensure
                                            your success.</p>
                                        <a to="service-details.html" className="btn btn-secondary-outline">
                                            Read More
                                            <div className="btn-icon btn-icon-sm">
                                                <span>
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                                <span>
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4">
                                <div className="service-item jos" data-jos_once={1} data-jos_animation="fade-up" data-jos_timingfunction="ease" data-jos_duration="0.5" data-jos_delay="0.3" data-jos_counter={1}>
                                    <div className="service-image-block">
                                        <a to="service-details.html" className="service-image-link">
                                            <img src="assets/images/service-thumbnail-6.jpg" alt="service-thumbnail-6" width={364} height={266} className="img-cover service-thumbnail" />
                                        </a>
                                        <div className="service-icon">
                                            <img src="assets/images/icons/service-icon-6.svg" alt="service-icon-6" width={41} height={41} />
                                            <img src="assets/images/icons/service-icon-hover-6.svg" alt="service-icon-hover-6" width={41} height={41} />
                                        </div>
                                    </div>
                                    <div className="service-content">
                                        <a to="service-details.html" className="service-link">Maritime Transportation</a>
                                        <p className="service-summery">We are committed to providing the best services to ensure
                                            your success.</p>
                                        <a to="service-details.html" className="btn btn-secondary-outline">
                                            Read More
                                            <div className="btn-icon btn-icon-sm">
                                                <span>
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                                <span>
                                                    <i className="fa-regular fa-arrow-right" />
                                                </span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div> */}
                            </div>
                        </div>
                    </div>
                </section>
                <div style={{ marginTop: "150px" }}>
                    <HomeServices />
                </div>
            </div>




        </>
    )
}

export default Services